
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/vaer",
      function () {
        return require("private-next-pages/[region]/[resort]/vaer.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/vaer"])
      });
    }
  